/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
export { ColumnSpread } from './ColumnSpread.js'
export type { ColumnSpreadProps } from './ColumnSpread.types.js'
